/* eslint-disable no-return-assign */
import React from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import { get, getJson } from 'session'; 
import PropTypes from 'prop-types';
import * as actions from '../../actions';
import * as c from '../../constant';

function ViewOfficialReceipt({ paymentId }) {

  const token = get('token') || '';
  const authProfile = getJson('profile') || {};

  const src = `${process.env.REACT_APP_WS}${c.RPTAX_BILLING_EOR_URL.replace("{id}", paymentId)}?bearer_token=${token}&email=${_.get(authProfile, 'email')}&output=I`;

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="row">
            <div className="col-12 animated-spinner">
              <iframe
                style={{ width: '100%', height: 600, border: 'none' }}
                title="Official Receipt"
                src={src}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

ViewOfficialReceipt.propTypes = {
  paymentId: PropTypes.number.isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewOfficialReceipt);
